import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import axios from "axios";
import ApiList from "services/apiList";

export const getCalendarList = createAsyncThunk(
  "calendar/list",
  async (payload, { dispatch }) => {
    const response = await axios.get(
      `${ApiList.getFoodCalendarDataUrl}?m=${payload.m}&a=${payload.a}`
    );

    const { result } = response.data;

    return result;
  }
);

export const addCalendarFood = createAsyncThunk(
  "calendar/add/food",
  async (payload, { dispatch }) => {
    const response = await axios.post(ApiList.getFoodCalendarDataUrl, payload);

    const { result } = response.data;

    return {
      id: result.id,
      food_name: payload.food_name,
      time: result.time,
      date: result.date,
    };
  }
);

export const deleteCalendarFood = createAsyncThunk(
  "calendar/delete/food",
  async (id, { dispatch }) => {
    await axios.delete(`${ApiList.getFoodCalendarDataUrl}${id}/`);
    return id;
  }
);

export const getCourseOptions = () => async (dispatch) => {
  const response = await axios.get(ApiList.getBagtsOptions);
  const { result } = response.data;

  return dispatch(setCourseOptions(result));
};

export const getFoodOptions = () => async (dispatch) => {
  const response = await axios.get(ApiList.getFoodListUrl);
  const { result } = response.data;

  return dispatch(setFoodOptions(result));
};

const calendarAdapter = createEntityAdapter({});

export const { selectAll: getCalendarData, selectById: getCalendarItem } =
  calendarAdapter.getSelectors((state) => state.food.calendarSlice);

const modalInitialValues = {
  open: false,
  date: null,
  time: 1,
  course: null,
};

const calendarSlice = createSlice({
  name: "calendar",
  initialState: calendarAdapter.getInitialState({
    foodOptions: [],
    courseOptions: [],
    filters: {
      course: null,
      month: new Date().getMonth(),
      day: "Даваа",
    },
    model: modalInitialValues,
  }),
  reducers: {
    setOpenModal: (state, action) => {
      state.model = action.payload;
    },
    setCloseModal: (state, action) => {
      state.model = modalInitialValues;
    },
    setCourseOptions: (state, action) => {
      state.courseOptions = action.payload;

      if (action.payload.length > 0) {
        state.filters.course = action.payload[0].id;
      }
    },
    setFoodOptions: (state, action) => {
      state.foodOptions = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCalendarList.fulfilled, (state, action) => {
      calendarAdapter.setAll(state, action.payload);
    });
    builder.addCase(addCalendarFood.fulfilled, (state, action) => {
      calendarAdapter.addOne(state, action.payload);
      state.model = modalInitialValues;
    });
    builder.addCase(deleteCalendarFood.fulfilled, (state, action) => {
      calendarAdapter.removeOne(state, action.payload);
    });
  },
});

export const {
  setCourseOptions,
  setFoodOptions,
  setFilters,
  setCloseModal,
  setOpenModal,
} = calendarSlice.actions;

export default calendarSlice.reducer;
